import User from "./User";

export default interface Store {
    id: string;
    codes: string[];
    name: string;
    entities: EntityTypes[];
    users: User[]
}

export enum EntityTypes {
  DEFAULT = 0,
  EPSE = 1,
  SIDJ = 2,
  JVB = 6,
  JCE = 8,
}